import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { from } from 'rxjs';
import { WkAlfrescoApiService } from './wk-alfresco-api.service';
import { SnackbarErrorAction } from '../store';

@Injectable({
  providedIn: 'root',
})
export class WKGenericPropertyUpdateService {
  private readonly contentType = ['application/json'];

  constructor(
    private readonly apiService: WkAlfrescoApiService,
    private readonly store: Store
  ) {}

  updateProperty(nodeId: string, propertyName: string, propertyValue: any) {
    return from(
      this.apiService
        .callContentClientCustomApi({
          path: `alfresco/s/wk/core/updateProperty/${nodeId}?property=${propertyName}`,
          httpMethod: 'PUT',
          bodyParam: propertyValue,
          contentTypes: this.contentType,
          accepts: this.contentType,
        })
        .catch((error) => {
          this.store.dispatch(new SnackbarErrorAction(error.message));
          if (error.status !== 404) {
            throw Error(error);
          }
        })
    );
  }
}
